import * as React from "react";

const SvgChevronLeft = props => <svg width="100%" height="100%" viewBox="0 0 5 9" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M4.04858 9L5 7.9425L1.90958 4.5L5 1.0575L4.04858 -8.31755e-08L-5.55655e-07 4.5L4.04858 9Z" fill="currentColor" /></svg>;

export default SvgChevronLeft;